/** API レスポンスの共通型 */
export interface ApiResponse<T> {
  code: number;
  data: T;
}

/** API エラーコード定数 */
export const API_ERROR_CODES = {
  SUCCESS: 0,
  UNKNOWN: 1,
  INVALID_TOKEN: 3,
  EMAIL_NOT_FOUND: 10,
  INVALID_EMAIL: 11,
  EMAIL_REGISTED: 12,
  FAILED_SEND_EMAIL: 16,
  INCORRECT_PASSWORD: 21,
  ACCESS_DENIED: 41,
  FORBIDDEN_IMAGE: 42,
  BLOCK_USER: 60,
  NOT_ENOUGH_POINT: 70,
  /** add_fav: 既にいいね済み（サーバーはメッセージを送らない） */
  ALREADY_ADDED_FAVORITE: 3117,
  LOCKED_USER: 81,
  FAILED_PROCESS_POINT: 86,
  CALL_PERMISSION_OFF: 82,
  PARTNER_NOT_WAITING: 83,
  PARTNER_IS_NOW_CALLING: 85,
  PARTNER_BROADCASTING: 89,
  AUTH_CODE_ALREADY_ISSUED: 9200,
  INVALID_AUTH_CODE: 9203,
  USER_ALREADY_REGISTERED: 9205,
  CALL_NOT_IN_PROGRESS: 9320,
  LOVENSE_IS_OFFLINE: 5007,
  LOVENSE_SESSION_NOT_FOUND: 5011,
  PAIDY_CAPTURE_FAILED: 2800,
  POINT_GRANT_FAILED: 2801,
  POINT_GRANT_ALREADY_FAILED: 2802,
  STRIPE_CAPTURE_FAILED: 2810,
  YAMATO_INVOICE_NOT_FOUND: 9360,
  YAMATO_INVOICE_NOT_REGISTERED: 9380,
  YAMATO_API_ERROR: 9381,
  YAMATO_API_COMMUNICATION_ERROR: 9382,
  YAMATO_NOT_DELIVERED_YET: 9385,
  YAMATO_MAINTENANCE: 9386,
  SUPER_CHAT_NOT_AVAILABLE: 9721,
  SUPER_CHAT_LIVE_NOT_FOUND: 9722,
  // ライブアンケート（9733/9734 は管理画面専用のため持たない）
  LIVE_POLL_NOT_AVAILABLE: 9730,
  LIVE_POLL_NOT_FOUND: 9731,
  LIVE_POLL_CLOSED: 9732,
  // ログイン情報再設定（credential_reset_request）
  CREDENTIAL_RESET_USER_NOT_IDENTIFIED: 9827,
  CREDENTIAL_RESET_CODE_ALREADY_ISSUED: 9828,
  CREDENTIAL_RESET_RATE_LIMIT_EXCEEDED: 9831,
  // Hokage → Carina 移行済み（ログイン時に BE が返す）
  HOKAGE_MIGRATED_TO_CARINA: 9774,
  // Hokage サービス終了後のログイン（暫定値。BE の採番に合わせてここだけ直す）
  HOKAGE_SERVICE_ENDED: 9775,
} as const;

/** API エラークラス */
export class ApiError extends Error {
  code: number;

  constructor(code: number, message: string) {
    super(message);
    this.name = "ApiError";
    this.code = code;
  }
}
